import { ArrayEnumerable } from "../sync/ArrayEnumerable.js";
export const bindArray = (jsArray) => {
    const arrayEnumerablePrototype = ArrayEnumerable.prototype;
    const bindToPrototype = jsArray.prototype;
    const propertyNames = Object
        .getOwnPropertyNames(arrayEnumerablePrototype);
    for (const prop of propertyNames) {
        bindToPrototype[prop] = bindToPrototype[prop] ?? arrayEnumerablePrototype[prop];
    }
};
